module.exports = __webpack_public_path__ + "img/selected5-min.a023a030.png";